// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#Special {\n  width: 200px;\n  float: right;\n}", "",{"version":3,"sources":["webpack://src/pages/CorporateRegistersComponents/CorporateRegister.styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ","sourcesContent":["#Special { \n    width: 200px; \n    float: right;\n  \n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
